import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { push as Push } from 'redux-first-history';
import { Header } from '@dev/ee-components';
import { safelyEncodeBase64Url } from '@dev/ee-tools';

import { ContactsPaths } from '@/services/dictionaries/Paths';
import { getPathParams } from '../../helperFunctions';
import { NavigationProps } from '../AddInterface';

export const Navigation = (props: NavigationProps): JSX.Element => {
    const { segmentName, listName } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const returnToPrevPage = (): void => {
        dispatch(
            Push(
                listName || segmentName
                    ? path.replace(pathParam, safelyEncodeBase64Url(breadcrumbName))
                    : ContactsPaths.ContactsOverview
            )
        );
    };

    const [path, pathParam, breadcrumbName] = getPathParams(segmentName, listName);
    return (
        <div>
            <Header
                header={{ title: t('addcontact') }}
                breadcrumbs={{
                    text: listName || segmentName ? breadcrumbName : t('overview'),
                    onClick: returnToPrevPage,
                }}
            />
        </div>
    );
};
